import React, { useEffect, useState, useRef } from "react";
import useFetchData from "../../utils/hooks/useFetchData";
import Comunication_green from "../../assets/images/Communications_green.png";
import Comunication_red from "../../assets/images/Communications_red.png";
import Comunication_orange from "../../assets/images/Communications_orange.png";
import Comunication_yellow from "../../assets/images/Communication_yellow.png";
import Ilumination_green from "../../assets/images/Ilumination_green.png";
import Ilumination_red from "../../assets/images/Ilumination_red.png";
import Ilumination_orange from "../../assets/images/Ilumination_orange.png";
import Ilumination_yellow from "../../assets/images/Ilumination_yellow.png";
import { Card } from "antd";
import { PrioritiesIncidents } from "../Widgets/PrioritiesIncidents";
import styled from "styled-components";
import NOVA_map from "../../assets/images/NOVA_map.png";

const incidentWidgetStyle = {
    width: '30%',
    padding: '10px',
    zIndex: '1000',
    position: 'absolute',
    top: '0',
    left: '0',
    backgroundColor: 'white',
    border: '1px solid black'
};

const mapContainerStyle = {
    position: 'relative',
    width: '100%',
    // height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const latTop = 38.7349;    // Exemplo: Latitude do topo da imagem
const latBottom = 38.7315; // Latitude do fundo da imagem
const lngLeft = -9.1631;  // Longitude da esquerda da imagem
const lngRight = -9.1582; // Longitude da direita da imagem

// Componente Marker
const Marker = ({ x, y, onClick, info, imageUrl }) => (
    <MarkerWrapper style={{ left: x, top: y }} onClick={onClick}>
        <img src={imageUrl} alt="POI" style={{ width: '30px', height: '30px' }} />
    </MarkerWrapper>
);

export const LightingAndWifi = ({ changeToLightingOrWifi }) => {
    const [pois, setPois] = useState(null);
    const [lightingAndWifi, setLightingAndWifi] = useState(null);
    const [type, setType] = useState('Exterior Lighting');

    const mapRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 10, height: 10 });

    const { data: lightingOrWifiItemsData, refetch: refetchLightingOrWifiData } = useFetchData('/nova_wallboards/getLightingOrWifiData', { type: type });

    useEffect(() => {
        if (lightingOrWifiItemsData) {
            setPois(lightingOrWifiItemsData?.data);
            setLightingAndWifi(lightingOrWifiItemsData);
        }
    }, [lightingOrWifiItemsData])

    useEffect(() => {
        refetchLightingOrWifiData();
    }, [type])

    // Gestão do setTimeout dentro de useEffect para evitar múltiplos timers
    useEffect(() => {
        const timer = setTimeout(() => {
            if (type === 'Exterior Lighting') {
                changeToLightingOrWifi('Wi-Fi');
                setType('Wi-Fi');
            } else {
                changeToLightingOrWifi('Iluminação');
                setType('Exterior Lighting');
            }
        }, 30000); // 30 segundos

        // Cleanup do timer quando o componente desmonta ou antes de executar novamente
        return () => clearTimeout(timer);
    }, [type, changeToLightingOrWifi]);

    useEffect(() => {
        const updateDimensions = () => {
            if (mapRef.current) {
                setDimensions({
                    width: mapRef.current.offsetWidth,
                    height: mapRef.current.offsetHeight,
                });
            }
        };

        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    // Função para converter lat/lng para x/y
    const convertLatLngToXY = (lat, lng) => {
        const { width, height } = dimensions;
        const x = ((lng - lngLeft) / (lngRight - lngLeft)) * width;
        const y = ((latTop - lat) / (latTop - latBottom)) * height;
        return { x, y };
    };

    return (
        <div style={mapContainerStyle}>
            <Card.Grid style={incidentWidgetStyle}>
                <PrioritiesIncidents data={lightingAndWifi?.events} />
            </Card.Grid>
            <div style={{ height: '90%', width: '90%', padding: '5px', border: '1px solid black', borderRadius: '5px' }}>
                <MapContainer ref={mapRef}>
                    <MapImage src={NOVA_map} alt="Mapa" />
                    {pois?.map(marker => {
                        const { x, y } = convertLatLngToXY(marker.latitude, marker.longitude);
                        return (
                            <Marker
                                key={marker.id}
                                x={x}
                                y={y}
                                // onClick={() => onMarkerClick(marker)}
                                info={marker.info}
                                imageUrl={correctImageToRender(marker)}
                            />
                        );
                    })}
                </MapContainer>
            </div>
        </div>
    );
};

function correctImageToRender(poi) {
    if (poi.family === "Living.Illumination") {
        if (poi.associatedIncidentPriority === '1 - High') {
            return Ilumination_red;
        } else if (poi.associatedIncidentPriority === '2 - Medium High') {
            return Ilumination_orange;
        } else if (poi.associatedIncidentPriority === '3 - Medium') {
            return Ilumination_yellow;
        } else {
            return Ilumination_green;
        }
    } else {
        if (poi.associatedIncidentPriority === '1 - High') {
            return Comunication_red;
        } else if (poi.associatedIncidentPriority === '2 - Medium High') {
            return Comunication_orange;
        } else if (poi.associatedIncidentPriority === '3 - Medium') {
            return Comunication_yellow;
        } else {
            return Comunication_green;
        }
    }
}

// Styled Components
const MapContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    overflow: hidden; /* Impede que o conteúdo ultrapasse o contêiner */
`;

const MapImage = styled.img`
    position: absolute;
    width: 100%;
    /* height: 100%; */
    object-fit: cover;
`;

const MarkerWrapper = styled.div`
    position: absolute;
    transform: translate(-50%, -100%); /* Centraliza o marcador */
    cursor: pointer;
`;